import { cardBrandData } from "../../utils/cardBrandData";

/**
 * A node for a Trie representing a CardBrand
 *
 * The property `cardInfo` is populated with the card information associated with the prefix
 * when it is a leaf node, and thus completing a prefix branch.
 */
class CardBrandTrieNode {
  cardInfo: (typeof cardBrandData)[number] | null;

  children: Record<string, CardBrandTrieNode>;

  constructor() {
    this.children = {};
    this.cardInfo = null;
  }
}

export default CardBrandTrieNode;
